import React, { useState, useEffect } from "react";
import LinearGradient from "react-native-linear-gradient";
import { StyleSheet, View, Image, TouchableOpacity } from "react-native";

//Custom Imports
import { scale } from "@utils/scale";
import color from "@constants/color";
import t from "@constants/localization";
import CustomText from "@components/CustomText";
import AnnouncementBanner from "./AnnouncementBanner";
import ShareGray from "@assets/svg/Contest/ShareGray";
import DottedLine from "@assets/svg/Contest/DottedLine";
import { CONTEST_EVENTS } from "@constants/analyticsEventsCT";

const PATH = "screens/Contest/contestDetails";

const MyPerformance = ({
  item = {},
  tl_image = "",
  tl_name = "",
  navigation,
  trackEvent = () => {},
  contest_id = "",
}) => {
  const {
    current_slab_index = 0,
    customers_made = "",
    level_reached = "",
    rewards_earned = "",
    sku_ids = {},
    slabs = [],
    contest_result_viewed = false,
    performance = "",
  } = item;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    !contest_result_viewed &&
      setTimeout(() => {
        setVisible(true);
      }, 200);
  }, [contest_result_viewed]);

  const captureAndShare = () => {
    trackEvent(CONTEST_EVENTS.RESULT_SHARED, {
      screen: "Contest details page",
      level: level_reached,
      reward: rewards_earned,
      metric_name: "Customers made",
      metric: customers_made,
    });
  };

  return (
    <View style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.titleText}
      >
        {t(`${PATH}/myPerformance`)}
      </CustomText>
        <LinearGradient
          colors={[color.lightOrange, color.veryLightOrange]}
          style={styles.myTaskCard}
        >
          <View style={styles.header}>
            <CustomText
              variant="title_20"
              newfont={true}
              numberOfLines={1}
              style={styles.nameText}
            >
              {t(`${PATH}/rewardsEarned`)}
            </CustomText>
            <TouchableOpacity
              onPress={captureAndShare}
              style={styles.shareIcon}
            >
              <ShareGray />
            </TouchableOpacity>
          </View>
          <DottedLine style={styles.dottedLine} width={"100%"} />
          <View style={styles.rewardContainer}>
            <Image
              resizeMode={"contain"}
              style={styles.rewardIcon}
              source={require("../../../assets/images/rewardIcon.png")}
            />
            <CustomText
              variant="heading_24"
              newfont={true}
              style={styles.rewardText}
            >
              {`₹${rewards_earned}`}
            </CustomText>
          </View>
          <View style={styles.customerLevelContainer}>
            <View style={styles.viewContainer}>
              <CustomText
                variant="body_text_3"
                newfont={true}
                numberOfLines={1}
                style={styles.customerText}
              >
                {t(`${PATH}/customersMade`)}
              </CustomText>
              <CustomText
                variant="heading_24"
                newfont={true}
                numberOfLines={1}
                style={styles.digitText}
              >
                {customers_made}
              </CustomText>
            </View>
            <View style={styles.viewContainer}>
              <CustomText
                variant="body_text_3"
                newfont={true}
                numberOfLines={1}
                style={styles.customerText}
              >
                {t(`${PATH}/levelReached`)}
              </CustomText>
              <CustomText
                variant="heading_24"
                newfont={true}
                numberOfLines={1}
                style={styles.digitText}
              >
                {level_reached}
              </CustomText>
            </View>
          </View>
        </LinearGradient>
      <AnnouncementBanner
        item={item}
        visible={visible}
        setVisible={setVisible}
        tl_image={tl_image}
        tl_name={tl_name}
        navigation={navigation}
        trackEvent={trackEvent}
        contestId={contest_id}
        performance={performance}
      />
    </View>
  );
};

export default MyPerformance;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingHorizontal: 16,
    marginTop: 15,
  },
  titleText: {
    color: color.mediumBlack,
  },
  myTaskCard: {
    flexDirection: "column",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: scale(10),
    backgroundColor: color.white,
    marginTop: 8,
    padding: 16,
  },
  header: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  shareIcon: {
    position: "absolute",
    alignSelf: "flex-end",
    zIndex: 100,
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  nameText: {
    color: color.mediumBlack,
    maxWidth: "80%",
  },
  dottedLine: {
    marginTop: 12,
    alignSelf: "center",
  },
  rewardIcon: {
    width: scale(160),
    height: scale(160),
    marginTop: 11,
  },
  rewardContainer: {
    width: scale(140),
    height: scale(140),
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  rewardText: {
    color: color.white,
    position: "absolute",
  },
  customerLevelContainer: {
    marginTop: 15,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
  customerText: {
    color: color.mediumBlack,
  },
  digitText: {
    color: color.mediumBlack,
    marginTop: 4,
  },
  viewContainer: {
    alignItems: "center",
  },
});
